import {LiquidationStatus} from "./LiquidationStatus";

export const LiquidationStatusColors: Record<LiquidationStatus, "primary" | "secondary" | "error" | "success" | "default"> = {
  [LiquidationStatus.IN_PROGRESS]: "primary",
  [LiquidationStatus.SUBMITTED]: "secondary",
  [LiquidationStatus.TO_FIX]: "error",
  [LiquidationStatus.CLOSE]: "success",
};
